export const mapping = {
    ACCOUNT_MANAGER: 'Account manager',
    PROJECT_MANAGER: 'Project manager'
};

export const options = [
    { value: 'ACCOUNT_MANAGER', label: 'Account manager' },
    { value: 'PROJECT_MANAGER', label: 'Project manager' }
];
